export default function ClockIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33464 9.99984C3.33464 6.31794 6.3194 3.33317 10.0013 3.33317C13.6832 3.33317 16.668 6.31794 16.668 9.99984C16.668 13.6817 13.6832 16.6665 10.0013 16.6665C6.3194 16.6665 3.33464 13.6817 3.33464 9.99984ZM10.0013 1.6665C5.39893 1.6665 1.66797 5.39746 1.66797 9.99984C1.66797 14.6022 5.39893 18.3332 10.0013 18.3332C14.6037 18.3332 18.3346 14.6022 18.3346 9.99984C18.3346 5.39746 14.6037 1.6665 10.0013 1.6665ZM10.8346 5.4165C10.8346 4.95627 10.4615 4.58317 10.0013 4.58317C9.54106 4.58317 9.16797 4.95627 9.16797 5.4165V9.99984C9.16797 10.4601 9.54106 10.8332 10.0013 10.8332H12.918C13.3782 10.8332 13.7513 10.4601 13.7513 9.99984C13.7513 9.5396 13.3782 9.1665 12.918 9.1665H10.8346V5.4165Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
